/* eslint-disable no-param-reassign */
// this is what @reduxjs/toolkit expects
import { createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import { redFunnelAPI } from 'api/api'
import getErrorMessage from 'utilities/getErrorMessage'

const initialState = {
  isLoading: false,
  isError: null,
  data: null,
}

export const fetchMyTravelCards = createAsyncThunk('myTravelCards/fetch', id =>
  redFunnelAPI
    .getTravelCards(id)
    .then(res => {
      const data = Object.values(res?.data?.travelCards || {}).reduce(
        (obj, card) => {
          const currentBalance = obj.balance || 0
          return {
            ...obj,
            balance: currentBalance + (card.balance ? +card.balance : 0),
            cards: [...obj.cards, card],
          }
        },
        {
          balance: 0,
          cards: [],
        },
      )
      return data
    })
    .catch(err => {
      const message = getErrorMessage(err, 'Unauthorized travel cards')
      throw new Error(message)
    }),
)

export const myTravelCardsReducer = createReducer(initialState, builder => {
  builder
    .addCase(fetchMyTravelCards.pending, state => {
      state.isLoading = true
    })
    .addCase(fetchMyTravelCards.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      state.isError = null
    })
    .addCase(fetchMyTravelCards.rejected, (state, action) => {
      state.isLoading = false
      state.data = null
      state.isError = action.payload
    })
})

export const selectMyTravelCardsState = state => state.myTravelCards
